class FWVatText extends HTMLElement {
  constructor() {
    super();

    this.renderText();
  }

  getCookie(name) {
    name = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  }

  renderText() {
    const vatList = {
      BE: 21,
      BG: 20,
      DK: 25,
      DE: 19,
      EE: 20,
      FI: 24,
      FR: 20,
      GR: 24,
      IE: 23,
      IT: 22,
      HR: 25,
      LV: 21,
      LT: 21,
      LU: 17,
      MC: 20,
      MT: 18,
      NL: 21,
      AT: 20,
      PL: 23,
      PT: 23,
      RO: 19,
      SE: 25,
      SK: 20,
      SI: 22,
      ES: 21,
      CZ: 21,
      HU: 27,
      CY: 19,
    };

    if (Object.keys(vatList).indexOf(this.getCookie("localization")) >= 0) {
      this.innerHTML = `Incl. {} VAT. `.replace(
        "{}",
        `${vatList[this.getCookie("localization")]}%`
      );
    } else {
      this.innerHTML = `Excl. VAT – local taxes or import duties may apply. `;
    }
  }
}

customElements.define("fw-vat-text", FWVatText);

